import {
  Alert, Typography, Button, Box,
} from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { generatePath, Link } from 'react-router-dom';
import { ROUTES } from '../../../consts';
import { ROUTE_VIEW_MODE } from '../../../consts/enums';
import STRING_KEYS from '../../../language/keys';
import { alertStyle } from './style';

type MatchTalentInformationNotificationProps = {
  onApplyChanges: () => void;
  talentId: string,
  latestTalentVersion: string | null;
};

const MatchTalentInformationNotification = ({
  onApplyChanges,
  talentId,
  latestTalentVersion,
}: MatchTalentInformationNotificationProps): JSX.Element => {
  const { t: translate } = useTranslation();

  return (
    <Alert
      severity="info"
      style={ alertStyle.alert }
      action={ (
        <Box style={ alertStyle.actionContainer }>
          <Link
            to={ generatePath(ROUTES.TALENT_VIEW, { talentId, viewMode: ROUTE_VIEW_MODE.VIEW }) }
            target="_blank"
          >
            <Typography
              style={ alertStyle.actionText }
              color="primary.main"
            >
              {translate(STRING_KEYS.TALENT_VIEW_UPDATED_VERSION)}
            </Typography>
          </Link>
          <Button
            onClick={ onApplyChanges }
            variant="contained"
            style={ alertStyle.action }
          >
            {translate(STRING_KEYS.APPLY_CHANGES)}
          </Button>
        </Box>
      ) }
    >
      <Typography>
        {translate(STRING_KEYS.NEW_UPDATE_AVAILABLE)}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {translate(STRING_KEYS.VERSION, {
          version: latestTalentVersion,
        })}
      </Typography>
    </Alert>
  );
};

export default React.memo(MatchTalentInformationNotification);
